export default __webpack_public_path__ + "static/media/Faceebook.9b3c4281.svg";